var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormContext, useWatch } from 'react-hook-form';
import { FormControl, FormLabel, FormSelect, FormTextarea, Stack, } from 'shared/components';
import { enumLabelsAsOptions } from 'src/shared/utils';
import { IssueFormReasonLabels } from '../../types';
export var IssueReason = function () {
    var register = useFormContext().register;
    var reason = useWatch({ name: 'issueReason' });
    var options = enumLabelsAsOptions(IssueFormReasonLabels);
    return (_jsxs(Stack, __assign({ spacing: 2, mt: 3 }, { children: [_jsxs(FormControl, __assign({ isRequired: true }, { children: [_jsx(FormLabel, { children: "Select an issue:" }), _jsx(FormSelect, { register: register, name: "issueReason", placeholder: "Please select an issue reason.", options: options })] })), reason && (_jsxs(FormControl, __assign({ isRequired: true }, { children: [_jsx(FormLabel, { children: "Issue details (Include zen desk ticket if applicable)" }), _jsx(FormTextarea, { register: register, name: "issueDetails", displayErrors: true, rules: { required: 'Please enter issue details' } })] })))] })));
};
